import React from 'react';
import './form-field.scss';

interface FormFieldProps {
    label?: string;
    inlineLabel?: boolean;
    errorMessage?: string;
    children: React.ReactNode;
}

const FormField: React.FC<FormFieldProps> = ({ label, inlineLabel, errorMessage, children }) => {
    const hasError = !!errorMessage;
    return (
        <div className={`form-field-wrapper ${inlineLabel ? 'inline-label':''} ${hasError ? 'has-error':''} form-field-${label?.replace(' ','_').toLowerCase()}`}>
            {label && <label className="form-field-label">{label}</label>}
            <div className={'form-field-content'}>
                <div className={`form-field-input-wrapper ${hasError ? 'has-error':''}`}>{children}</div>
                {hasError && <span className="form-field-error">{errorMessage}</span>}
            </div>
        </div>
    );
};

export default FormField;